import { locationByLatLngQuery } from '../utils/queries';
export async function getLocDataByLatLng({
  lat,
  lng
} = {}, graphqlClient) {
  let zip = '';
  if (lat && lng) {
    try {
      const res = await graphqlClient.query({
        query: locationByLatLngQuery,
        variables: {
          latitude: lat,
          longitude: lng
        },
        ssr: true
      });
      zip = res.data.locationInfoByLatLng;
      if (!zip.isValid) {
        zip = null;
      }
    } catch (err) {
      console.log(err);
    }
  }
  return zip;
}
;
const getCurrentPosition = () => new Promise((resolve, reject) => {
  window.navigator.geolocation.getCurrentPosition(resolve, reject);
});
export async function getGeolocationLatLng() {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    const pos = await getCurrentPosition();
    const lat = pos.coords.latitude;
    const lng = pos.coords.longitude;
    return {
      lat,
      lng
    };
  } catch (err) {
    console.log(err);
  }
}
;
export const getGeoLocation = async client => {
  var latlng = await getGeolocationLatLng();
  if (latlng) {
    return getLocDataByLatLng(latlng, client);
  }
};